import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M6.5 5.5L0 12L6.5 18.5L7.207 17.793L1.914 12.5H24V11.5H1.914L7.207 6.207L6.5 5.5Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "ThinBigLeft"
);
